var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnicampLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 75,
    viewBox: "0 0 70 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.093 24.6853V0.651168C35.0054 0.715378 37.9065 1.11113 40.7292 1.84916C40.4379 3.49637 41.1772 5.14352 42.6109 6.09547L34.2773 25.1239C33.5604 24.8993 32.8323 24.7602 32.093 24.6853Z",
    fill: "#1F1A17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8957 24.6853V0.683234C25.9304 0.875737 22.0548 1.80633 18.4592 3.42144L27.7787 25.1024C28.462 24.8886 29.1676 24.7495 29.8957 24.6853Z",
    fill: "#1F1A17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0948 25.7061L16.8202 4.14275C13.2582 5.88628 10.0435 8.23941 7.35519 11.0739L24.0449 27.011C24.6722 26.5084 25.3555 26.0698 26.0948 25.7061Z",
    fill: "#1F1A17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.19955 12.3791C3.74647 15.1601 1.88713 18.3796 0.733354 21.8345L21.478 30.124C21.8364 29.4501 22.2845 28.8083 22.7998 28.2307L6.19955 12.3791Z",
    fill: "#1F1A17"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7498 31.7175L0.29642 23.5457C-0.174075 27.0326 -0.0844634 30.5623 0.56519 34.0171H20.2681C20.3353 33.2364 20.5034 32.4662 20.7498 31.7175Z",
    fill: "#1F1A17"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2747 35.7439H1.07583C2.24072 38.6319 3.75294 41.3701 5.56755 43.9264L20.7339 37.9794C20.4987 37.252 20.3419 36.5034 20.2747 35.7439Z",
    fill: "#1F1A17"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8284 41.415C22.2908 40.816 21.8315 40.1636 21.4619 39.4576L6.82192 45.1907C8.86049 47.1267 11.112 48.8274 13.5314 50.2928L22.8284 41.415Z",
    fill: "#1F1A17"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4686 54.2316C34.2558 52.5737 35.051 50.9586 36.5296 50.0601L34.211 44.5837C30.705 45.6213 26.8854 44.8832 24.0851 42.6157L15.1241 51.1725C21.0496 54.1782 27.8487 55.2584 34.4686 54.2316Z",
    fill: "#1F1A17"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7752 43.967L38.105 49.4862C39.9084 49.1974 41.7006 49.9782 42.6639 51.4543C43.6608 51.005 44.6465 50.5344 45.621 50.0424L37.881 42.6407C37.2313 43.1648 36.5256 43.614 35.7752 43.967Z",
    fill: "#1F1A17"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6283 37.899C62.9786 37.2893 62.5306 36.5085 62.3514 35.6421H41.6403C41.461 37.7706 40.5762 39.7921 39.1424 41.418L47.2633 49.1726C53.1663 46.0493 58.655 42.263 63.6283 37.899Z",
    fill: "#1F1A17"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9288 8.06912C52.9034 8.99965 53.8107 9.98372 54.6619 11.0212L37.8602 27.0653C37.2441 26.5733 36.5832 26.1562 35.8775 25.8032L44.2112 6.77485C45.757 7.07435 47.3587 6.56092 48.4228 5.43782C49.655 6.22932 50.8311 7.11715 51.9288 8.06912Z",
    fill: "#1F1A17"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.831 56.3299C40.3219 56.3299 41.5305 55.171 41.5305 53.7414C41.5305 52.3119 40.3219 51.153 38.831 51.153C37.3401 51.153 36.1315 52.3119 36.1315 53.7414C36.1315 55.171 37.3401 56.3299 38.831 56.3299Z",
    fill: "#DA251D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2893 37.0482C68.7864 37.0482 70 35.8894 70 34.4598C70 33.0303 68.7864 31.8714 67.2893 31.8714C65.7923 31.8714 64.5787 33.0303 64.5787 34.4598C64.5787 35.8894 65.7923 37.0482 67.2893 37.0482Z",
    fill: "#DA251D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0779 5.17686C46.575 5.17686 47.7886 4.01798 47.7886 2.58843C47.7886 1.15888 46.575 0 45.0779 0C43.5809 0 42.3673 1.15888 42.3673 2.58843C42.3673 4.01798 43.5809 5.17686 45.0779 5.17686Z",
    fill: "#DA251D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.307 74.9876V68.1955H14.3537L18.4981 72.8807V68.2386H20.6264V74.9876H17.3781L13.3904 70.5383V74.9876H11.307Z",
    fill: "#1F1A17"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4127 74.9876V68.142H24.4065V74.9876H22.4127Z",
    fill: "#1F1A17"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.39 72.4925H34.3726V73.4017C34.3726 74.3429 33.5213 75.081 32.5356 74.9847H28.4136C27.3831 74.9847 26.5318 74.2467 26.4198 73.2734V69.8506C26.4198 68.8345 27.3495 68.0322 28.4136 68.1392H32.5356C33.4877 68.1392 34.283 68.8237 34.3838 69.7222V70.6421H32.39C32.3788 70.1822 31.9756 69.8292 31.4939 69.8506H29.4105C28.884 69.8292 28.436 70.2142 28.4136 70.7063V72.4177C28.436 72.9204 28.884 73.2947 29.4105 73.2734H31.4939C31.9644 73.2947 32.3676 72.9524 32.39 72.4925Z",
    fill: "#1F1A17"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3883 73.9101L37.8992 75H35.7795L38.7143 68.2272H41.9753L44.9917 75H42.709L42.383 73.9101H38.3883ZM41.5677 72.2753H39.122L40.3449 69.395L41.5677 72.2753Z",
    fill: "#1F1A17"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6625 71.0749V74.9574H46.6686V68.1118H48.9649L52.5605 73.4491L55.9097 68.1118H58.1723V74.9574H56.1785V71.2887L53.871 74.9574H51.2724L48.6625 71.0749Z",
    fill: "#1F1A17"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0057 74.9876V68.0592H66.283C67.2613 68.0592 67.995 68.8377 68.1581 69.7718V71.6402C68.1581 72.5744 67.2613 73.4307 66.283 73.4307H62.1253V74.9876H60.0057ZM62.1253 71.5623V69.8497H65.3047C66.5275 69.8497 66.5275 71.5623 65.3047 71.5623H62.1253Z",
    fill: "#1F1A17"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.57686 72.3792V68.1007H0.583034V73.3098C0.583034 74.2189 1.35592 74.9462 2.29685 74.9462H7.88627C8.83831 74.9462 9.60001 74.2189 9.60001 73.3098V68.1542H7.60618V72.3792C7.60618 72.8498 7.203 73.2349 6.71013 73.2349H3.47299C2.98012 73.2349 2.57686 72.8498 2.57686 72.3792Z",
    fill: "#1F1A17"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.956 22.1901C59.9479 19.9118 58.8389 17.6763 57.6292 15.4836C57.0131 14.4461 56.3635 13.43 55.6802 12.4352L39.1137 28.2548C39.6401 28.8645 40.0994 29.5169 40.469 30.2122L60.956 22.1901Z",
    fill: "#1F1A17"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6689 23.778C62.6657 26.2487 63.573 28.7623 64.3572 31.308C63.349 31.9177 62.6322 32.9017 62.3745 34.0248H41.6523C41.5851 33.2654 41.4395 32.5167 41.193 31.7894L61.6689 23.778Z",
    fill: "#1F1A17"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnicampLogo);
export default __webpack_public_path__ + "static/media/UnicampLogo.72f85d56b96d9a3f2534af73725d569b.svg";
export { ForwardRef as ReactComponent };